import { Component, OnInit, Input } from '@angular/core';
import { Globals } from 'src/app/globals';
import { AdmService } from 'src/app/service/adm.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-cand-section3',
  templateUrl: './cand-section3.component.html',
  styleUrls: ['./cand-section3.component.scss']
})
export class CandSection3Component implements OnInit {
  @Input() candData: any;

  showLoader: boolean = false;
  questionData: any;

  constructor(public globals: Globals, public admService: AdmService, public translate: TranslateService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getCandidateQuestions();
    // console.log("all ques : "+this.questionData);
  }

  checkDataExist() {
    // console.log(this.candData);
    return (typeof this.candData === 'object' && this.candData !== null)
  }

  getCandidateQuestions() {
    this.showLoader = true;
    let secNumber = 3;
    this.admService.getQuestionByCandidateAndSec(this.candData.id, secNumber).subscribe(
      data => {
        this.questionData = data.map((question: any) => {

          return { candQuesId: question.id, id: question.questionid, questionDescAr: "", questionDescEn: "", values: [], answer: question.valueDesc };
        });
        // Get number of candidate questions
        // this.numberOfQuestions = this.questionData.length;
        this.questionData.forEach((element: any) => {
          this.getQuestionById(element.id);
        });
        this.questionData = this.questionData;
      },
      error => {
        this.toastr.error(this.translate.instant('CAN_NOT_GET_DATA_BE'));
        this.showLoader = false;
      },
      () => {
        // console.log("all ques : " + this.questionData);
        this.showLoader = false;
      }
    );
  }

  getQuestionById(questionId: number) {
    this.admService.getQuestionById(questionId).subscribe(
      data => {
        this.questionData = this.questionData.map((question: any) => {
          if (question.id == questionId) {

            return { candQuesId: question.candQuesId, id: data.id, questionDescAr: data.questionDescAr, questionDescEn: data.questionDescEn, questionType: data.questionType, values: question.values, answer: question.answer };
          } else {
            return question
          }
        });
      },
      error => {
        this.toastr.error(`can't get question#${questionId}`);
        this.showLoader = false;
      },
      () => {
        this.showLoader = false;
      }
    );
  }


}
